import axios from 'axios';
import * as actionTypes from 'Constants/redux';

// Platform storefront domain for this environment — mirrors the API's storefront_domain secret
// (config/secrets.yml) and the admin's convertCpHostName. Local dev uses the *.dev.tapgoods.net
// wildcard (-> 127.0.0.1) over plain HTTP, because .dev is HSTS-preloaded and we have no local TLS.
const platformStorefrontDomain = () => {
  switch (process.env.REACT_APP_APP_ENV) {
    case 'development':
      return 'dev.tapgoods.net';
    case 'stage':
      return 'stage.tapgoods.dev';
    case 'preprod':
      return 'preprod.tapgoods.dev';
    case 'upgrade':
      return 'upgrade.tapgoods.dev';
    case 'production':
    default:
      // Only a build that positively identifies itself as local dev gets the wildcard domain.
      // cp_stage.env and infrastage.env omit REACT_APP_APP_ENV entirely, so they land here:
      // sending them to *.dev.tapgoods.net would resolve to the user's own machine (127.0.0.1)
      // and break the payment-link redirect outright. Keep the historical production host.
      return 'tapgoods.com';
  }
};

export const fetchLocationFromToken = (token) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_LOCATION_REQUEST });

    return axios
      .get(process.env.REACT_APP_API_DOMAIN + '/api/external_login', {
        params: {
          token: token,
        },
      })
      .then((response) => {
        const setting = response.data.location.storefrontSetting;
        let base = '';

        if (setting.storefrontEnabled) {
          // A registered custom domain is a real, externally hosted site: always https, and never
          // our local port. Deployed environments are unaffected — window.location.port is empty
          // there — but this does deliberately drop the old local-dev port append, which built an
          // unreachable https://<custom-domain>:3001.
          base = `https://${setting.domain}`;
        } else {
          let domain =
            response.data.location.subdomain + '.' + platformStorefrontDomain();

          if (window.location.port !== '') {
            domain = domain + ':' + window.location.port;
          }

          // Platform subdomains are plain HTTP in local dev and https everywhere deployed, so
          // follow the current page's scheme rather than hardcoding it.
          const scheme =
            window.location.protocol === 'http:' ? 'http' : 'https';
          base = `${scheme}://${domain}`;
        }

        window.location.replace(`${base}/makeAPayment/${token}`);
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.FETCH_LOCATION_FAILURE,
        });
      });
  };
};
